var map = {
	"./chart-biankuangtu.svg": "477b",
	"./chart-bingtu.svg": "d5b1",
	"./chart-gundong-table.svg": "d60d",
	"./chart-zhixiantu.svg": "76b6",
	"./chart-zhuzhuangtu.svg": "57a3",
	"./funnel.svg": "d5c9",
	"./icon-kefu.svg": "c1e7",
	"./icon-logout.svg": "4c70",
	"./icon-msg.svg": "8d8a",
	"./icon-password.svg": "f8ac",
	"./menu-app.svg": "1272",
	"./menu-doc.svg": "cf2a",
	"./menu-edit.svg": "058c",
	"./menu-home.svg": "bb1a",
	"./menu-mall.svg": "23c1",
	"./menu-settings.svg": "1bd0",
	"./menu-user.svg": "01f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";